import React from 'react';
import { Card } from '../../../../components/ui/Card';
import { cn } from '../../../../utils/cn';

/**
 * Tarjeta KPI alineada con el sistema de diseño (tokens + dark mode automático).
 *
 * - `icon` es un componente de lucide-react (ej. `TrendingUp`).
 * - `tone` controla el color del chip del ícono via tokens semánticos
 *   (brand / success / error / warning / info / neutral).
 */
const toneChip = {
  brand: 'bg-brand-50 text-brand-600',
  success: 'bg-status-success-soft text-status-success',
  error: 'bg-status-error-soft text-status-error',
  warning: 'bg-status-warning-soft text-status-warning',
  info: 'bg-status-info-soft text-status-info',
  neutral: 'bg-status-neutral-soft text-fg-muted',
};

const KpiCard = ({ title, value, sub, tone = 'brand', icon: Icon }) => (
  <Card padding="md" className="metric-card h-full flex items-center gap-3">
    {Icon && (
      <div
        className={cn(
          'metric-card__icon flex items-center justify-center w-11 h-11 rounded-lg shrink-0',
          toneChip[tone] ?? toneChip.brand,
        )}
      >
        <Icon className="w-[18px] h-[18px]" />
      </div>
    )}
    <div className="metric-card__content min-w-0">
      <h3 className="metric-card__title text-[13px] font-medium text-fg-muted mb-1">
        {title}
      </h3>
      <div className="metric-card__value text-2xl font-bold text-fg leading-tight tabular-nums">
        {value}
      </div>
      {sub && (
        <p className="metric-card__subtitle text-xs text-fg-subtle mb-0 mt-0.5">{sub}</p>
      )}
    </div>
  </Card>
);

export default KpiCard;
